<div *ngIf="invitation.status == eInvitation.Transfer;else other_status">
    <h1 [innerHTML]="'Le transfert a ete annule par
        $name$.' | transloco:{name: invitation.account.organization_name | escapeHtml}"></h1>
    <p
       [innerHTML]="'Afin de connaitre la raison, nous vous invitons a prendre contact avec $name$ directement.' | transloco:{name: invitation.account.organization_name | escapeHtml}">
    </p>
</div>
<ng-template #other_status>
    <div
         *ngIf="invitation!==null && invitation.account!==null && invitation.account.organization_name!==null;else without_account">
        <h1
            [innerHTML]="'L\'invitation a annule par $name$.' | transloco: {name: invitation.account.organization_name | escapeHtml}">
        </h1>
        <p
           [innerHTML]="'Afin de connaitre la raison, nous vous invitons a prendre contact avec $name$ directement.' | transloco:{name: invitation.account.organization_name | escapeHtml}">
        </p>
    </div>
    <ng-template #without_account>
        <h1>{{'L\'invitation a ete annule.' | transloco}}</h1>
        <p>{{'Afin de connaitre la raison, nous vous invitons a prendre contact avec l\'organisation directement.' | transloco}}
        </p>
    </ng-template>
</ng-template>
